import config from "../config";
import { sendGetRequest, sendPutRequest, concatOptionalParameter } from "../Utility/FetchUtils";
import { ELightPath, PlateTypeCaptureProfile } from "../Model/CaptureProfile";

class PlateTypeCaptureProfileApi {
  static BASE_URL = config.SERVICE_URL + "/plate-type-capture-profiles";

  static getPlateTypeCaptureProfiles(id?: number, imagerIdentifier?: string, lightPath?: ELightPath) {
    let url = this.BASE_URL + "/";

    url = concatOptionalParameter(url, {
      id: id,
      "imager-identifier": imagerIdentifier,
      lightpath: lightPath,
    });

    return sendGetRequest<PlateTypeCaptureProfile[]>(url);
  }

  static updatePlateTypeCaptureProfile(plateTypeCaptureProfile: PlateTypeCaptureProfile) {
    let url = this.BASE_URL + "/";
    return sendPutRequest(url, plateTypeCaptureProfile);
  }
}

export default PlateTypeCaptureProfileApi;
